<template>
  <div class="home">
    <bless-page :hasPhone="hasPhone" :needLogin="needLogin"></bless-page>
    <register
      :visible.sync="registerVisible"
      :getCode="getCode"
      :onSumbit="register"
      @beginEnterPhoneNum="beginEnterPhoneNum"
    />
    <!-- <iframe class="login-iframe" :src="loginPagelink" :width="loginWidth" :height="loginHeight" v-if="showLogin"/> -->
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { mapGetters } from 'vuex'
import { createTicketByMj } from '@/common/js/fingerprintDevice'
import { CUSTOM_EVENT_ID } from '../../define/customEventId'
import { USER_FLAG } from '../../define/userData'
import { ERROR_CODE_ENUM } from '../../define/errorCodeEnum'
import {
  checkUserApi,
  RegisterApi,
  SmsCodeCommonApi,
  getShareContent
} from '../../api/home'
import bus from '../../js/bus'
import YunJi from '@/common/js/YunJi'
import { exposureThinkingReport } from '../../../../common/js/Util'
/**
 * 登录组件事件类型
 */
const LOGIN_EVENT_TYPE = {
  /**
   * 登陆关闭
   */
  LOGIN_CLOSE: 'LOGIN_CLOSE',
  /**
   * 登陆成功
   */
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  /**
   * 打开新页面
   */
  OPEN_PAGE: 'OPEN_PAGE'
}
export default {
  name: 'home',
  data() {
    return {
      registerVisible: false,
      hasPhone: false,
      needLogin: false,
      showLogin: false,
      tick: ''
    }
  },
  computed: {
    ...mapGetters(['appCont', 'shopId', 'isFromHeJi', 'luckBagCode', 'smsId']),
    loginPagelink() {
      return `${location.protocol}//${globalConfig.yunjibuyerPath}/yjbuyer/login-common?shopId=968&target=${encodeURIComponent(location.href)}`
      // return 'http://t-do-dev.yunjiglobal.com/yjbuyer/loginIframe?shopId=968'
    },
    // loginWidth(){
    //   return document.documentElement.clientWidth
    // },
    // loginHeight(){
    //   return document.documentElement.clientHeight
    // }
    ticket() {
      return YunJi.getUrlParams('ticket') || ''
    }
  },
  watch: {
    registerVisible(value) {
      console.log('registerVisible: ', value)
    },
    showLogin() {
      if (this.showLogin) {
        // var r=confirm("即将跳转登陆页面")
        // if(r){
        //   window.location.href = this.loginPagelink
        // }
        window.location.href = this.loginPagelink
      }
    }
  },
  components: {
    register: () => import('../../components/register/index'),
    blessPage: () => import('../../components/blessPage')
  },
  created() {
    // document.cookie = 'cookie=ticket|2_22191ba7ea36078c7aa7ac6771dd419d;path=/;domain=yunjiglobal.com;'
    if (this.ticket) {
      YunJi.setJPCookie('JESSIONID_PHONE', this.ticket, 30)
    }
    this.checkUser()
  },
  mounted() {
    this.initEvent()
    window.addEventListener('unload', e => this.beforeunloadFn(e))
    window.addEventListener('pagehide', e => this.beforeunloadFn(e))
    // window.onunload = this.beforeunloadFn()
  },
  destroyed() {
    this.beforeunloadFn()
  },
  methods: {
    beforeunloadFn() {
      localStorage.setItem('ceshiceshi', '11111')
      const ids = exposureThinkingReport()
      window.thinkingReport.track('exposure', {
        page_id: '81023',
        point_id: '29038',
        item_id: ids.join(','),
        content_name: +this.appCont === 7 ? '小程序' : 'h5',
        point_name: '离开曝光'
      })
      console.log({
        page_id: '80612',
        point_id: '26436',
        content_type: '内容类型',
        item_id: ids.join(','),
        point_name: '离开曝光'
      })
    },
    /**
     * 初始化事件
     */
    initEvent() {
      bus.$on('SHOW_REGISTER_ALIERT', (flag) => {
        this.registerVisible = flag
      })
      bus.$on('SHOW_LOGIN', (flag) => {
        this.showLogin = flag
      })
      bus.$on(CUSTOM_EVENT_ID.GET_USER_INFO_BY_SHOPID, (userInfo) => {
        console.log(userInfo)
        thinkingReport.setPageProperty({ consumer_id: userInfo && userInfo.currentConsumerId })
        this.initLoadPointId()
        // this.registerVisible = flag;
      })
      // window.addEventListener('message', this.onMessage)
    },
    // onMessage(event){
    //   let {data} = event
    //   let { messageType, messageContent } = data
    //   switch(messageType){
    //     case LOGIN_EVENT_TYPE.LOGIN_CLOSE:
    //       this.showLogin = false
    //       break
    //     case LOGIN_EVENT_TYPE.LOGIN_SUCCESS:
    //       this.needLogin = false
    //       this.showLogin = false
    //        YunJi.setJPCookie("JESSIONID_PHONE", messageContent, 30);
    //        window.location.reload()
    //       // this.checkUser()
    //       break
    //     case LOGIN_EVENT_TYPE.OPEN_PAGE:
    //       window.location.href = messageContent
    //       break
    //   }
    //   console.log('@xts->onMessage: ', event, messageType)
    // },
    /**
     * 初始化load埋点id
     */
    initLoadPointId() {
      thinkingReport.track('exposure', {
        point_id: this.isFromHeJi ? '26469' : '25548',
        page_id: '80586',
        content_id: this.luckBagCode,
        sms_id: this.smsId
      })
      // 新版福袋加载
      thinkingReport.track('page_load', {
        point_id: '27016',
        page_id: '80740',
        content_id: this.luckBagCode,
        sms_id: this.smsId
      })
      // 拆福袋按钮-曝光
      thinkingReport.track('page_load', {
        point_id: '27017',
        page_id: '80740',
        content_id: this.luckBagCode,
        sms_id: this.smsId
      })
    },
    // initWxshareConfig(params) {
    //   let linkUrl = params.url || window.location.href;
    //   if (linkUrl.indexOf("appCont") < 0) {
    //     linkUrl = `${linkUrl}&appCont=0`;
    //   }
    //   this.wxShare({
    //     content: params.subContent || "一万人已拆出5元无门槛，我看你也行",
    //     link: linkUrl,
    //     imgUrl:
    //       params.icon ||
    //       "https://static.yunjiglobal.com/qnUpload/frontend/membercenter/recallShare.png",
    //     title: params.mainContent || "送你一个福袋，看看能拆出啥~",
    //     callback: () => {
    //       // 分享成功回调
    //     },
    //     configDone: (data, res) => {
    //       // console.error(data)
    //     },
    //   });
    // },
    getShareInfo() {
      getShareContent({
        appCont: this.appCont
      }).then((res) => {
        if (res.code === 0 || res.errorCode === 0) {
          this.initWxshareConfig(res.data || {})
        } else {
          this.initWxshareConfig({})
        }
      })
    },
    beginEnterPhoneNum() {
      thinkingReport.track('others', {
        point_id: '25620',
        page_id: '80586',
        content_id: this.luckBagCode
      })
    },
    // 获取指纹设备tick
    getFingerprintTick() {
      createTicketByMj().then((res) => {
        this.tick = res.tick || ''
      })
    },
    // 检查用户是需要登录
    checkUser() {
      checkUserApi({
        appCont: this.appCont
      }).then((res) => {
        this.registerVisible = this.needLogin = this.showLogin = false
        const code = 'code' in res ? res.code : res.errorCode 
        const { userFlag } = res.data || {}
        if (code == 0) {
          if (userFlag === USER_FLAG.NO_PHONE) {
            this.needLogin = this.showLogin = true
          } else if (code === 0 && userFlag === USER_FLAG.HAS_PHONE) {
            // 获取微信分享数据
            // this.getShareInfo();
            // 该用户已绑定过
            this.hasPhone = true
          } else {
            Toast('userFlag异常')
          }
        } else if (code == ERROR_CODE_ENUM.LOGIN) {
          this.needLogin = this.showLogin = true
        }
      }, (res) => {
      })
    },
    /**
     * 提交登录方法
     */
    async register(phoneNo, smsCode) {
      thinkingReport.track('others', {
        point_id: '25621',
        page_id: '80586',
        content_id: this.luckBagCode,
        sms_id: this.smsId
      })
      // 这里后端要求写死传16。渠道类型：16季卡会员官方，17口令计划，19农场，20事后
      const params = {
        phone: `${phoneNo}`,
        countryCode: '86',
        smsCode: `${smsCode}`,
        activityType: 16,
        shopId: this.shopId || 968,
        appCont: this.appCont
      }
      const { code, msg, errorMessage } = await RegisterApi(params)
      if (code === 0 || code === '0') {
        this.registerVisible = false
        this.hasPhone = true
      } else {
        Toast(msg || errorMessage || '网络异常')
      }
    },
    /**
     * 获取验证码方法，只有return true了组件才会开始倒数
     */
    async getCode(phoneNo) {
      const params = {
        phone: `${phoneNo}`,
        countryCode: '86',
        scenNo: 100127,
        t: new Date().getTime(),
        riskParams: JSON.stringify({
          tick: this.tick
        })
      }
      let result = false
      const { errorCode, errorMessage } = await SmsCodeCommonApi(params)
      if (errorCode === 0 || errorCode === '0') {
        result = true
      } else {
        Toast(errorMessage || '网络异常')
      }
      return result
    }
  }
}
</script>

<style lang="stylus" scoped>
.login-iframe{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
}
</style>
